import { useIntl } from 'react-intl';

import { useApplicationRuntimeContext } from '@context/ApplicationRuntimeContext';
import { IFormattedPrice } from '@model';

export const useFormattedSecondaryPrice = (price: number): IFormattedPrice | null => {
  const { formatNumber } = useIntl();

  const {
    applicationSettings: { secondaryCurrency },
  } = useApplicationRuntimeContext();

  if (!secondaryCurrency || secondaryCurrency.conversionRate === 0) {
    return null;
  }

  const formattedPrice = formatNumber(price / secondaryCurrency.conversionRate, {
    minimumFractionDigits: secondaryCurrency.decimalPlaces,
    maximumFractionDigits: secondaryCurrency.decimalPlaces,
  }).toString();

  return {
    price: formattedPrice,
    currencyFormat: secondaryCurrency.currencyFormat,
    currencySymbol: secondaryCurrency.currencySymbol,
    originalValue: price / secondaryCurrency.conversionRate,
  };
};
